export default theme => ({
    settingMenu: {},
    sourceOptionHeader: {
        padding: '4px',
    },
    loadingIndicator: {
        position: 'absolute',
        top: '50%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
    },
    hidden: {
        display: 'none',
    },
    sourceOptionItem: {
        padding: '4px',
        borderTop: `2px solid ${theme.palette.common.grey}`,
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: `${theme.palette.common.grey3}`,
            textDecoration: 'underline',
        },
    },
    sourceOptionsList: {
        position: 'absolute',
        opacity: '0.9',
        bottom: '40px',
        backgroundColor: `${theme.palette.common.faintBlack}`,
        right: '10px',
        zIndex: '1',
        borderRadius: '4px',
    },
    videoContainer: {
        height: '100%',
        width: ({ viewportWidth, media_is360 }) => (media_is360 ? viewportWidth : '100%'),
        '& > div': {
            width: '100%',
            margin: ({ isMobile }) => (isMobile ? '4px' : '0px'),
            height: ({ media_is360 }) => (media_is360 ? '100%' : null),
            // mobile
            [theme.breakpoints.down('xs')]: {
                margin: '0',
            },
        },
        '& > div#vjs_video_3': {
            height: ({ media_is360 }) => (media_is360 ? '100%' : null),
        },
        '& > canvas': {
            width: ({ viewportWidth, media_is360 }) => (media_is360 ? viewportWidth : null),
        },
        '& > .video-js': {
            height: ({ media_is360 }) => (!media_is360 ? '100%' : null),
        },
        '& > .video-js .vjs-video-canvas': {
            height: ({ isMobile, media_is360 }) => (media_is360 && isMobile ? '100% !important' : null),
        },
        '& > .video-js .vjs-menu-button-inline.vjs-slider-active,.video-js .vjs-menu-button-inline:focus,.video-js .vjs-menu-button-inline:hover,.video-js.vjs-no-flex .vjs-menu-button-inline': {
            width: '10em',
        },
        '& > .video-js .vjs-controls-disabled .vjs-big-play-button': {
            display: 'none!important',
        },
        '& > .video-js .vjs-control': {
            width: '3em',
            margin: '0 4px',
        },
        '& > .video-js .vjs-menu-button-inline:before': {
            width: '1.5em',
        },
        '& > .vjs-menu-button-inline .vjs-menu': {
            left: '3em',
        },
        '& > .vjs-paused.vjs-has-started.video-js .vjs-big-play-button,.video-js.vjs-ended .vjs-big-play-button,.video-js.vjs-paused .vjs-big-play-button': {
            display: 'block',
        },
        '& > .video-js .vjs-load-progress div,.vjs-seeking .vjs-big-play-button,.vjs-waiting .vjs-big-play-button': {
            display: 'none!important',
        },
        '& > .video-js .vjs-mouse-display:after,.video-js .vjs-play-progress:after': {
            padding: '0 .4em .3em',
        },
        '& > .video-js.vjs-ended .vjs-loading-spinner': {
            display: 'none',
        },
        // '& > .video-js.vjs-ended .vjs-big-play-button': {
        //   display: 'block !important'
        // },
        // '& > video-js.vjs-ended .vjs-big-play-button,.video-js.vjs-paused .vjs-big-play-button,.vjs-paused.vjs-has-started.video-js .vjs-big-play-button': {
        //   display: 'block'
        // },
        '& > .video-js .vjs-big-play-button': {
            display: 'none !important',
            // top: '50%',
            // left: '50%',
            // marginLeft: '-1.5em',
            // marginTop: '-1em',
        },
        // '& > .video-js:hover .vjs-big-play-button,.video-js .vjs-big-play-button:focus,.video-js .vjs-big-play-button:active': {
        //   backgroundColor: null
        // },
        '& > .video-js .vjs-loading-spinner': {
            borderColor: null,
        },
        '& > .video-js .vjs-control-bar2': {
            backgroundColor: 'transparent',
        },
        '& > .video-js .vjs-control-bar': {
            backgroundColor: 'rgba(0,0,0,0) !important',
            color: `${theme.palette.common.white}`,
            fontSize: '11px',
            marginBottom: '16px',
        },
        '& > .video-js .vjs-volume-panel': {
            order: '4',
            marginTop: '1.75px',
            marginRight: ({ isMobile, media_is360 }) => (media_is360 && isMobile ? '20px' : '12px'),
            '@media (max-width: 400px)': {
                position: 'absolute',
                right: '-10px',
                bottom: '30px',
            },
        },
        '& > .video-js .vjs-volume-control': {
            opacity: '0.9',
        },
        '& > .video-js .vjs-poster': {
            opacity: '0 !important',
            display: 'none !important',
        },
        '& > .video-js .vjs-youtube-mobile': {
            opacity: '0 !important',
            display: 'none !important',
        },
        '& > .video-js .vjs-resize-manager': {
            opacity: '0 !important',
            display: 'none !important',
        },
        '& > .video-js .vjs-remaining-time': {
            position: 'absolute !important',
            right: '80px',
            top: '75%',
            width: '33px',
            height: '20px',
            fontFamily: 'CircularStd, sans-serif',
            fontSize: '16px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textAlign: 'right',
            color: '#ffffff',
        },
        '& > .video-js .vjs-play-progress, .video-js  .vjs-volume-level': {
            backgroundColor: '#4a90e2',
        },
        '& >  .video-js .vjs-fullscreen-control': {
            display: 'none',
        },
        '& >  .video-js .vjs-VR-control': {
            display: 'none',
        },
        '& > .video-js .vjs-current-time': {
            display: 'block !important',
            position: 'absolute !important',
            left: '34px',
            top: '75%',
            width: '33px',
            height: '20px',
            fontFamily: 'CircularStd, sans-serif',
            fontSize: '16px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: 'normal',
            letterSpacing: 'normal',
            textAlign: 'right',
            color: `${theme.palette.common.white}`,
        },
        '& > .video-js .vjs-setting-button': {
            display: 'flex !important',
            margin: '0 2px 0 4px',
            cursor: 'pointer',
            '& > div': {
                display: 'flex',
                flexDirection: 'column-reverse',
            },
            '& > div > button': {
                cursor: 'pointer',
            },
        },
        '& > .video-js .vjs-caption-button': {
            display: 'flex !important',
            margin: '0 2px 0 4px',
            cursor: 'pointer',
            '& > div': {
                display: 'flex',
                flexDirection: 'column-reverse',
            },
            '& > div > button': {
                cursor: 'pointer',
            },
        },
        '& > .video-js .vjs-volume-control': {
            left: '-3em',
            margin: '0 4px 0 2px',
        },
        '& > .video-js .vjs-volume-control.vjs-volume-vertical': {
            left: '-3.6em',
            backgroundColor: 'rgb(0,0,0,0.5)',
        },
        '& > .video-js .vjs-embedded-title': {
            position: 'absolute',
            width: '81%',
            height: '46px',
            bottom: '70px',
            left: '40px',
            fontFamily: theme.typography.fontFamily,
            fontSize: '36px',
            fontWeight: '500',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: '46px',
            letterSpacing: 'normal',
            textAlign: 'left',
            color: `${theme.palette.common.white}`,
            textShadow: '0 6px 20px rgba(0, 0, 0, 0.4)',
            userSelect: 'none',
            pointerEvents: 'none',
        },
        '& > .video-js .vjs-embedded-title.vjs-fade-out': {
            display: 'block',
            visibility: 'hidden',
            opacity: 0,
            '-webkit-transition': 'visibility 1.5s, opacity 1.5s',
            '-moz-transition': 'visibility 1.5s, opacity 1.5s',
            '-ms-transition': 'visibility 1.5s, opacity 1.5s',
            '-o-transition': 'visibility 1.5s, opacity 1.5s',
            transition: 'visibility 1.5s, opacity 1.5s',
        },
        '& > .video-js .vjs-scene-return-button': {
            position: 'absolute',
            bottom: '80px',
            right: '40px',
            cursor: 'pointer',
            '@media (max-width: 400px)': {
                top: '16px',
                right: '16px',
                height: '40px',
            },
            '& > button': {
                padding: '12px 20px',
                cursor: 'pointer',
                width: '122px',
                height: '38px',
                borderRadius: '4px',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                border: `solid 1.5px ${theme.palette.common.white}`,
                '& > div': {
                    height: '15px',
                    fontFamily: 'CircularStd, sans-serif',
                    fontSize: '12px',
                    fontWeight: '500',
                    fontStyle: 'normal',
                    fontStretch: 'normal',
                    letterSpacing: 'normal',
                    color: `${theme.palette.common.white}`,
                },
            },
            '&.vjs-fade-out': {
                display: 'block',
                visibility: 'hidden',
                opacity: 0,

                '-webkit-transition': 'visibility 1.5s, opacity 1.5s',
                '-moz-transition': 'visibility 1.5s, opacity 1.5s',
                '-ms-transition': 'visibility 1.5s, opacity 1.5s',
                '-o-transition': 'visibility 1.5s, opacity 1.5s',
                transition: 'visibility 1.5s, opacity 1.5s',
            },
        },
    },
    disabledButton: {
        opacity: '0.5',
        cursor: 'default',
        '& > button': {
            opacity: '0.5',
            cursor: 'default',
        },
    },
    selectedSrc: {
        backgroundColor: `${theme.palette.common.grey3}`,
    },
})
